import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/crt/pricing-excise/')({
  loader: () => {
    throw redirect({
      to: `/crt/pricing-excise/pricing-assumptions`,
    })
  },
})
